import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//
import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';
//
import { setTypeMouseCursor } from 'app/actions/Core/css.effect.action';
import withTranslations from 'app/components/HOGs/withTranslations';
//
import mapUtils from 'app/libs/Utils/mapUtils';
//
import { Type } from 'app/constants/TourPoints';
import { TwisterTypeName } from 'app/constants/twisterType.constants';

import { useActions } from 'app/components/Utility/hooks/useAction.hooks';
import RideTwisterSlider from './components/RideTwisterSlider';
import RideTwisterRecalculation from './components/RideTwisterRecalculation';
import RideTwisterSetPoint from './components/RideTwisterSetPoint';
import { RTService } from '../RideTwister.service';

let ent = null;

const ToPoint = (props) => {
  const dispatch = useDispatch();
  const {
    loadingRecalculate,
    sliderValue,
    loading,
    setLoading,
    points,
    init,
    // edit,
    // pointsData,
  } = props;

  const { setGPSDataLoadingStatus } = useActions();

  const [startPoint, setStartPoint] = useState(points[0]);
  const [endPoint, setEndPoint] = useState(points[points.length - 1]);
  const { getCoefficient, showRT, getFirstLastPoint } = RTService;

  const highway = useSelector((store) => store.tourFullData.highway);
  const ferry = useSelector((store) => store.tourFullData.ferry);
  const getAvoidSettings = () => ({
    highway,
    ferry,
  });

  useEffect(() => {
    if (points[0] && points[0].lat && points[0].lng) {
      setStartPoint(points[0]);
    }
    if (
      points[points.length - 1] &&
      points[points.length - 1].lat &&
      points[points.length - 1].lng
    ) {
      setEndPoint(points[points.length - 1]);
    } else {
      setEndPoint({});
    }
    if (points.length === 1) {
      setEndPoint({});
    }
  }, [points]);

  const addPointToDrive = (lat, lng) => {
    setEndPoint({ lat, lng });
    publish(way.DRIVE_MAP_CLICK, {
      lat,
      lng,
      type: Type.END,
      draggable: true,
    });
  };

  const takeAddressByClickMap = () => {
    dispatch(setTypeMouseCursor(`cursor_${Type.END}`));
    setTimeout(() => {
      publish(way.CLUB_EDIT_GET_ADDRESS_FROM_MAP_ON, (e) => {
        const { lat, lng } = e.latlng;
        addPointToDrive(lat, lng);
        publish(way.CLUB_EDIT_GET_ADDRESS_FROM_MAP_OFF);
        dispatch(setTypeMouseCursor(''));
      });
    }, 0);
  };

  useEffect(() => {
    const { lat: sLat, lng: sLng } = startPoint || {};
    const { lat: eLat, lng: eLng } = endPoint || {};
    if (sLat && sLng && !eLat && !eLng) {
      takeAddressByClickMap();
    }
  }, [startPoint]);

  const setRTRoute = (e) => {
    showRT(e);
    if (loading) {
      setLoading(false);
    }
    setGPSDataLoadingStatus({ fetching: false, fetched: true });
  };

  // const setRTRoute = (rtParams) => {
  //   const rtRlCb = () => {
  //     if (loading) {
  //       setLoading(false);
  //     }
  //   };
  //   showRT({ ...rtParams, rtRlCb });
  //   setGPSDataLoadingStatus({ fetching: false, fetched: true });
  // };

  useEffect(() => {
    const { first, last } = getFirstLastPoint(points);
    const coef = getCoefficient(sliderValue);
    if ((first && last && !init) || (loadingRecalculate && !init)) {
      if (coef === 0) {
        publish(way.DRIVE_ADD_POINT_BY_FINGER_DRAW, {
          points: [first, last],
          round: true,
        });
      } else {
        if (ent) {
          clearTimeout(ent);
        }
        ent = setTimeout(() => {
          const options = {
            coefficient: coef,
            type: TwisterTypeName.ToPoint,
            coorditanes: `${first.lng},${first.lat};${last.lng},${last.lat}`,
            correction: false,
            overview: 'full',
          };
          mapUtils.twisterServiceOSRM(options, setRTRoute, {
            avoid: getAvoidSettings(),
          });
        }, 500);

        // setRTRoute({
        //   coefficient: coef,
        //   type: TwisterTypeName.ToPoint,
        //   coorditanes: `${first.lng},${first.lat};${last.lng},${last.lat}`,
        //   correction: false,
        //   point: points[points.length - 1],
        //   isEdit: edit,
        //   oncePointData: pointsData,
        // });
      }
    }
  }, [sliderValue, loadingRecalculate]);

  return (
    <div className="toPoint">
      <div className="mainLayout">
        <RideTwisterSlider {...props} />
        <RideTwisterRecalculation {...props} />
      </div>
      <RideTwisterSetPoint
        {...props}
        setStartPoint={setStartPoint}
        startPoint={startPoint}
      />
    </div>
  );
};

export default withTranslations(ToPoint);
